import type creatorZh from '../zh/creator';

const creator: typeof creatorZh = {
  title: 'Quản lý KOL',
  tabs_label: 'Phân loại quản lý KOL',
  tab_mine: 'KOL của tôi',
  tab_blacklist: 'Danh sách chặn KOL',
  tab_collab: 'KOL hợp tác',
  tab_intent: 'KOL quan tâm',
  mine_subtitle: 'Đồng bộ KOL từ lưu ở quảng trường, lời mời, tin nhắn và email',
  blacklist_subtitle: 'Sau khi chặn, loại khỏi lời mời / tin nhắn / email',
  blacklist_hint:
    'Sau khi thêm, tin nhắn, email và lời mời định hướng sẽ tự gỡ. KOL đã có trong danh sách sẽ không hiện lại.',
  collab_subtitle: 'Đã hợp tác / đang hợp tác · xem chi tiết và thống kê',
  collab_hint:
    'Bao gồm đang hợp tác và đã có đơn. Dữ liệu từ hoàn thành đơn trong kho chọn sản phẩm và tổng quan bán hàng (giới hạn).',
  intent_subtitle: 'Đã liên hệ, có phản hồi, nhưng chưa vào hợp tác',
  intent_hint: 'Quy tắc: có email hoặc tin nhắn, và chưa vào KOL hợp tác. Không hiển thị danh sách chặn.',
  search_placeholder: 'Tìm KOL / biệt danh',
  last_channel: 'Kênh trả lời gần nhất',
  channel_dm: 'Tin nhắn',
  channel_email: 'Email',
  reply_counts: 'Tin nhắn {{dm}} · Email {{email}}',
  batch_outreach: 'Kết nối hàng loạt',
  batch_invite: 'Mời hàng loạt',
  find_talent: 'Tìm KOL',
  add_invite: 'Thêm vào lời mời',
  send_dm: 'Gửi tin nhắn',
  send_email: 'Gửi email',
  mine_count: 'Tổng {{count}} người',
  load_failed: 'Không tải được danh sách KOL của tôi',
  intent_load_failed: 'Không tải được KOL quan tâm',
  collab_load_failed: 'Không tải được KOL hợp tác',
  col_source: 'Nguồn hợp tác',
  source_invite_accepted: 'Đã chấp nhận lời mời',
  source_chat: 'Chuyển từ trao đổi',
  col_added_products: 'Sản phẩm đã thêm',
  blacklist_load_failed: 'Không tải được danh sách chặn',
  blacklist_current: 'Đang chặn',
  blacklist_history: 'Lịch sử gỡ',
  removed_tag: 'Đã gỡ',
  tag_none: 'Không nhãn',
  col_talent: 'KOL',
  col_tags: 'Nhãn',
  gmv30: 'GMV 30 ngày',
  followers: 'Người theo dõi',
  col_actions: 'Thao tác',
  tag_coop: 'Hợp tác',
  tag_high_conv: 'Chuyển đổi cao',
  tag_intent: 'Quan tâm',
  outreach: 'Kết nối',
  unfavorite: 'Bỏ lưu',
  unfavorite_confirm: 'Bỏ lưu {{name}}?',
  unfavorite_success: 'Đã bỏ lưu {{name}}',
  unfavorite_failed: 'Không bỏ lưu được KOL này',
  add_blacklist: 'Thêm vào danh sách chặn',
  col_added_by: 'Người thêm',
  col_region: 'Khu vực',
  col_added_at: 'Thời gian thêm',
  col_reason: 'Lý do',
  remove: 'Gỡ',
  remove_confirm: 'Gỡ {{name}} khỏi danh sách chặn?',
  blacklist_removed: 'Đã gỡ khỏi danh sách chặn: {{name}}',
  blacklist_remove_failed: 'Không gỡ được khỏi danh sách chặn',
  blacklist_missing_remove_id: 'Thiếu ID của KOL, không thể gỡ',
  col_status: 'Trạng thái',
  col_start: 'Bắt đầu hợp tác',
  col_shop: 'Cửa hàng',
  col_product: 'Sản phẩm hợp tác',
  sales_gmv: 'GMV bán hàng',
  col_orders: 'Đơn hàng',
  sales_detail: 'Chi tiết bán hàng',
  no_sales_data: 'Chưa có dữ liệu bán hàng',
  col_stage: 'Giai đoạn',
  col_channels: 'Kênh liên hệ',
  col_last_interaction: 'Tương tác gần đây',
  col_last_content: 'Nội dung gần đây',
  col_reply: 'Phản hồi',
  view_email: 'Xem email',
  email_thread: 'Thư trao đổi: {{name}}',
  convert_collab: 'Chuyển sang hợp tác',
  convert_confirm: 'Chuyển {{name}} thành người hợp tác của cửa hàng hiện tại?',
  converted_collab: 'Đã chuyển sang hợp tác: {{name}}',
  convert_failed: 'Không chuyển sang hợp tác được',
  reason_poor: 'Thực hiện kém',
  reason_timeout: 'Quá hạn chưa gửi',
  reason_no_update: 'Nhắc nhiều lần không phản hồi',
  reason_fraud: 'Rủi ro gian lận',
  reason_policy: 'Vi phạm / khiếu nại',
  reason_other: 'Khác',
  remark: 'Ghi chú',
  select_talent_required: 'Vui lòng chọn KOL',
  blacklist_missing_id: 'Thiếu ID của KOL, không thể chặn',
  blacklist_failed: 'Thêm vào danh sách chặn thất bại',
  blacklist_added: 'Đã thêm vào danh sách chặn: {{talent}} ({{reason}})',
  select_talent: 'Chọn KOL',
  reason: 'Lý do',
  join: 'Thêm',
  col_item: 'Sản phẩm',
  col_coop_time: 'Thời gian hợp tác',
  col_showcase: 'Tủ trưng bày',
  col_videos: 'Video',
  col_live: 'Livestream',
  commission: 'Hoa hồng',
  video_live: 'Video / livestream',
  ctr: 'Tỷ lệ nhấp',
  collab_heading: '{{name}} · Chi tiết hợp tác',
  collab_meta: '{{handle}} · {{shop}} · Bắt đầu {{date}}',
  collab_detail: 'Chi tiết hợp tác'
};

export default creator;
